const prefix = 'PROJECTS';

export const GET_PROJECT_LIMITS = Symbol(`${prefix}/GET_PROJECT_LIMITS`);
export const GET_PROJECT_LIMITS_SUCCESS = Symbol(`${prefix}/GET_PROJECT_LIMITS_SUCCESS`);
export const SET_PROJECTS_LOADED = Symbol(`${prefix}/SET_PROJECTS_LOADED`);

export const GET_INITIAL_PROJECTS = Symbol(`${prefix}/GET_INITIAL_PROJECTS`);
export const GET_PROJECTS = Symbol(`${prefix}/GET_PROJECTS`);
export const GET_PROJECTS_SUCCESS = Symbol(`${prefix}/GET_PROJECTS_SUCCESS`);
export const GET_MORE_PROJECTS_SUCCESS = Symbol(`${prefix}/GET_MORE_PROJECTS_SUCESS`);
export const SEARCH_PROJECTS_SUCCESS = Symbol(`${prefix}/SEARCH_PROJECTS_SUCCESS`);
export const RESET_SEARCH_RESULTS = Symbol(`${prefix}/RESET_SEARCH_RESULTS`);
export const DELETE_PROJECT = Symbol(`${prefix}/DELETE_PROJECT`);
export const DELETE_PROJECT_SUCCESS = Symbol(`${prefix}/DELETE_PROJECT_SUCCESS`);
export const ARCHIVE_PROJECT = Symbol(`${prefix}/ARCHIVE_PROJECT`);
export const ARCHIVE_PROJECT_SUCCESS = Symbol(`${prefix}/ARCHIVE_PROJECT_SUCCESS`);
export const UPDATE_PROJECT_FAIL = Symbol(`${prefix}/UPDATE_PROJECT_FAIL`);
export const SET_PROJECT = Symbol(`${prefix}/SET_PROJECT`);

export const GET_PROJECT_FEATURES = Symbol(`${prefix}/GET_PROJECT_FEATURES`);
export const GET_PROJECT_FEATURES_SUCCESS = Symbol(`${prefix}/GET_PROJECT_FEATURES_SUCCESS`);
export const GET_PROJECT_FEATURES_FAIL = Symbol(`${prefix}/GET_PROJECT_FEATURES_FAIL`);
export const UPDATE_PROJECT_FEATURES = Symbol(`${prefix}/UPDATE_PROJECT_FEATURES`);
export const UPDATE_PROJECT_FEATURES_SUCCESS = Symbol(`${prefix}/UPDATE_PROJECT_FEATURES_SUCCESS`);
export const UPDATE_PROJECT_FEATURES_FAIL = Symbol(`${prefix}/UPDATE_PROJECT_FEATURES_FAIL`);
export const WEDDING_PERMISSIONS = Symbol(`${prefix}/WEDDING_PERMISSIONS`);
export const WEDDING_PERMISSIONS_SUCCESS = Symbol(`${prefix}/WEDDING_PERMISSIONS_SUCCESS`);
export const WEDDING_PERMISSIONS_FAIL = Symbol(`${prefix}/WEDDING_PERMISSIONS_FAIL`);
export const SET_WEDDINGS_PERMISSIONS = Symbol(`${prefix}/SET_WEDDINGS_PERMISSIONS`);
